import styled from 'styled-components';

export const RouteDetail = styled.div`
  flex: 1;
  padding: ${({ theme }) => `${theme.spacing.x2}`};
`;

export const Name1 = styled.div`
  font-size: ${({ theme }) => `${theme.fs.md}`};
`;
export const Name2 = styled.div`
  font-size: ${({ theme }) => `${theme.fs.xs}`};
`;

export const TextBlue = styled.div`
  margin: ${({ theme }) => `${theme.spacing.x2} 0`};
  font-weight: bold;
  color: ${({ theme }) => `${theme.palette.secondary}`};
`;
export const Form = styled.div`
  margin-bottom: ${({ theme }) => `${theme.spacing.x2} `};
  display: flex;
`;
export const Bullet = styled.div`
  margin-right: ${({ theme }) => `${theme.spacing.x2} `};
`;

export const Span = styled.span`
  border: 2px solid ${({ theme }) => theme.palette.secondary};
  width: ${({ theme }) => theme.spacing.x4};
  height: ${({ theme }) => theme.spacing.x4};
  margin-top: 2px;
  display: block;
  outline: ${({ theme }) => theme.palette.boxBackgroundDark} solid ${({ theme }) => theme.spacing.x1};
  position: relative;
  border-radius: 50%;
`;
export const BulletSpan = styled(Span)`
  &::before {
    content: '';
    position: absolute;
    top: calc(100% + 6px);
    width: 2px;
    height: ${({ theme }) => theme.spacing.x6};
    background: ${({ theme }) => theme.palette.secondary};
    left: 50%;
    transform: translateX(-50%);
  }
`;
export const FormInfo = styled.div`
  flex: 1;
  margin-right: ${({ theme }) => `${theme.spacing.x2} `};
`;

export const FlightFlightToInfo = styled.div`
  margin-right: ${({ theme }) => `${theme.spacing.x2} `};
`;

export const FlightFlightDate = styled.div`
  font-size: ${({ theme }) => `${theme.fs.xxs}`};
`;
export const FlightDeparture = styled.div`
  font-weight: 500;
`;

export const To = styled.div`
  display: flex;
`;

export const BulletSpan2 = styled(Span)`
  &::before {
    display: none;
  }
`;
